import { Projects } from "@modules";
import { Breadcrumb } from "@components";
import { useParams } from "react-router-dom";

export default function ProjectPage() {
  const { id } = useParams();

  return (
    <div className="container max-content">
      <Breadcrumb
        data={[
          { title: "Projects", href: "/projects" },
          { title: "Edit Project", href: `/projects/edit/${id}` },
        ]}
      />
      <h1 className="mb-8 text-3xl">Edit Project</h1>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <Projects.Edit id={id} />
        </div>
      </div>
    </div>
  );
}
